/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Body for recording GDPR consent before the in_exam segment.
 */
export interface OralExamRecordConsentRequest {
  policyVersion: string;
  scope: string;
}
